<div class="box">
  <div class="box-body">
    <div class="table-responsive">
      <table class="table table-striped gp-table">
        <thead>
        <tr role="row">
          <th class="text-sm">
            {{ 'FORMS.name' | translate }}
          </th>
          <th class="text-sm">
            {{ 'REPORTS.output_format' | translate }}
          </th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngIf="reports === null">
          <td colspan="10" class="text-center p-t-lg p-b-lg">
            <i class="fa fa-light fa-spinner fa-spin"></i>
          </td>
        </tr>
        <tr *ngIf="reports !== null && reports?.length === 0">
          <td colspan="10" class="text-center p-t-lg p-b-lg">
            {{ 'ESS.MY_TEAM.REPORTS.no_reports' | translate }}
          </td>
        </tr>
        <tr *ngFor="let report of reports | sortByTranslations:
                         triggerSortByTranslationPipe :['descriptionTransId'] | async">
          <td>
            {{report.descriptionTransId | translate}}
            <sup
              *ngIf="reportDefinitionService.hasDuplicate(report, reports)">{{report.gloRegTransId | translate}}</sup>
          </td>
          <td>
            {{report.contentType}}
          </td>
          <td class="pull-right">
            <button class="btn btn-sm btn-fw warn"
                    (click)="selectAndEmitReport(report)">
              <i class="fa fa-light pull-right fa-caret-square-right"></i>
              {{ 'COMMON.execute' | translate }}
              <i *ngIf="report.isLoading" class="fa fa-light fa-spinner fa-spin"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
